// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2Efzs","label":"LabeledBox_label__8KK9A"};